import templateUrl from './pay-stub-commissions.component.html'
import { PayrollTypeEnum } from '../../../core/services/data-services/payroll.service';

export const PayStubCommissionsComponent = {
    templateUrl,
    controllerAs: "vm",
    bindings: {
        payStubEntry: "<"
    },
    controller: class PayStubCommissionsComponent {
        deductGuaranteedFromCommission(payStubEntry) {
            return payStubEntry.PayrollType.PayrollTypeID === PayrollTypeEnum.CommissionExceedingGuaranteed
                && payStubEntry.SubtotalCommission !== payStubEntry.TotalCommissionAmount;
        }
    }
}
